<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('agentList.agentName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('agentList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						<el-form-item :label="$t('agentList.loginStatus')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('status.enable')" :value="1"></el-option>
								<el-option :label="$t('status.disable')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
                        <el-form-item :label="$t('agentList.agentType')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('agentList.allAgent')" :value="1"></el-option>
								<el-option :label="$t('agentList.oneAgent')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('agentList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" size="mini" @selection-change="handleSelectionChange">
				<el-table-column align="center" fixed prop="id" width="50" label="ID">
				</el-table-column>
				<el-table-column align="center" prop="name" width="100" :label="$t('agentList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="[scope.row.head]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="name" :label="$t('agentList.agentName')">
				</el-table-column>
				<el-table-column align="center" prop="username" :label="$t('agentList.loginName')">
				</el-table-column>
				<el-table-column align="center" prop="status" width="100" :label="$t('agentList.loginStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('agentList.normalLogin') : $t('agentList.forbidLogin')}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="type" :label="$t('agentList.agentType')">
                    <template slot-scope="scope">
						<span v-if="scope.row.type == 1" class="text_chengse">{{$t('agentList.allAgent') }}</span>
						<span v-if="scope.row.type == 2" >{{ $t('agentList.oneAgent') }}</span>
					</template>
				</el-table-column>
                <el-table-column align="center" prop="up_name" :label="$t('agentList.upAgent')">
				</el-table-column>
                <el-table-column align="center" prop="tg_id" :label="$t('agentList.TgAccount')">
				</el-table-column>
                <el-table-column align="center" prop="share_code" :label="$t('agentList.shareCode')">
				</el-table-column>
				<el-table-column align="center" prop="create_time" width="180" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column align="center" width="120" fixed="right" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'editAgent'" @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				:layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('agentList.edit') : $t('agentList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('agentList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'1'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
                <el-form-item :label="$t('agentList.tgQr')" prop="tg_qr">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'4'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccessTg"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.tg_qr" :src="form.tg_qr" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('agentList.agentName')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('agentList.agentName')"  style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item  :label="$t('agentList.loginName')" prop="username">
					<el-input :disabled="editIndex > -1" v-model="form.username" :maxlength="16" :minlength="6" :placeholder="$t('agentList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('agentList.loginPassword')" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password :placeholder="$t('agentList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('agentList.confirmPassword')" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password :placeholder="$t('agentList.confirmPassword')" size="small" style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item :label="$t('agentList.TgAccount')" prop="tg_id">
					<el-input v-model="form.tg_id" :maxlength="16" :minlength="6" :placeholder="$t('agentList.TgAccount')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('layout.email')" prop="email">
					<el-input v-model="form.email" :maxlength="16" :minlength="6" :placeholder="$t('layout.email')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('layout.phone')" prop="phone">
					<el-input v-model="form.phone" :maxlength="16" :minlength="6" :placeholder="$t('layout.phone')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('agentList.shareCode')" prop="share_code">
					<el-input v-model="form.share_code" :maxlength="16" :minlength="6" :placeholder="$t('agentList.shareCode')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('agentList.loginStatus')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('agentList.normalLogin')}}</el-radio>
						<el-radio :label="0" border>{{$t('agentList.forbidLogin')}}</el-radio>
					</el-radio-group>
				</el-form-item>
                <el-form-item  :label="$t('agentList.agentType')">
					<el-radio-group :disabled="editIndex > -1" v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('agentList.allAgent')}}</el-radio>
						<el-radio :label="2" border>{{$t('agentList.oneAgent')}}</el-radio>
					</el-radio-group>
				</el-form-item>
                <el-form-item  v-if="form.type == 2" :label="$t('agentList.upAgent')" prop="parent">
					<el-select :disabled="editIndex > -1" v-model="form.parent" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
						<el-option v-for="item in agent_list" :key="item.id" :label="item.newname" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				},
				auth_val: 'Agent',

				preUrl: "user/agentList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delAgent", //删除單条地址
				addUrl: "user/addAgent", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址

				tableData: [],
				form: {
                    name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
                        share_code:'',
						status: 1,
						parent: 0,
						type: 1,
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('agentList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('agentList.usernameRequired'),
						trigger: 'blur',
					}, {
						min: 6,
						max: 16,
						message: this.$t('agentList.usernameLength'),
						trigger: 'blur'
					}],
                    password: [{
						validator: this.validateParent, // 使用自定义校验
                        trigger: 'blur'
					}],
				},
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['agent']);
		},
		methods: {
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('agentList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('agentList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('agentList.upProfile'));
						
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						
						// 關閉模态框
					}
				})
			},
			hide(){
                this.form = {
						name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						share_code: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
						status: 1,
						parent: 1,
						type: 1,
					}
					this.editIndex = -1
                    this.createModel = false
               
            },
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						share_code: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
						status: 1,
						parent: 1,
						type: 1,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						username: e.row.username,
						headUrl:  e.row.head,
						tgQrUrl:  e.row.tg_qr,
						share_code:  e.row.share_code,
						tg_qr:  e.row.tg_qr,
						icon: e.row.head,
						phone: e.row.phone,
                        email: e.row.email,
                        tg_id: e.row.tg_id,
						status:  e.row.status,
						parent:  e.row.parent,
						type:  e.row.type,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agent_list = list.agent

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
            handleAvatarSuccessTg(res, file) {
				this.form.tg_qr = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.tgQrUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {

				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 12;

				if (!isJPG) {
				this.$message.error(this.$t('message.info_err'));
				}
				if (!isLt2M) {
				this.$message.error(this.$t('message.img_max_err'));
				}
				return isJPG && isLt2M;

			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
  color: #fff;
}
</style>
